import BasePaymentMethod from "./BasePaymentMethod";
import paymentApi from "../paymentApi";
import {EPaymentType} from "@/@types/payrix";
import Contact from "@/entities/contact";


class PaymentCreditCard extends BasePaymentMethod {
    constructor(props: any) {
        super(EPaymentType.Card);

        // Check props for Payrix-only field
        if (paymentApi.isPayrix()) {
            this.fromPayrix(props);
        }
        else {
            this.fromLawpay(props);
        }
    }

    clone() {
        // Use Object.assign spread to copy all properties, avoiding structuredClone issues
        const cl = new PaymentCreditCard({...this});
        cl.contact = this.contact ? new Contact(this.contact) : undefined;
        // Preserve CVV since fromPayrix() doesn't copy it (CVV is never stored by payment processors)
        cl.cvv = this.cvv;
        return cl;
    }
}

export default PaymentCreditCard;
